import { render, staticRenderFns } from "./UTag.vue?vue&type=template&id=a4428e36&scoped=true"
import script from "./UTag.vue?vue&type=script&lang=js"
export * from "./UTag.vue?vue&type=script&lang=js"
import style0 from "./UTag.vue?vue&type=style&index=0&id=a4428e36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4428e36",
  null
  
)

export default component.exports